import { Card, CardContent, CardHeader, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import axios from 'axios'
import CustomdropDown from '../../../../../components/utils/dropDown/customdropDown'
import { useFormik } from 'formik/dist'
import * as yup from "yup";
import _ from 'lodash'
import useStyle from './style'
import Loader from '../../../../../components/loader/loader'
import { Helmet } from 'react-helmet-async'
import { closeNav, loadNav } from '../../../../../components/hooks/menuLoad'
const MenuAuthorization = () => {
    const classes = useStyle()
const dispatch = useDispatch()
const [data, setData] = useState([]) // menu auth data
const [subMenuData , setSubmenuData] = useState([])
const [rolesData , setRolesData] = useState([])
const [active, setActive] = useState(false)
const [isLoader, setIsLoader] = useState(false); //loader
const pageOption = [10, 25, 50, 100];
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
const [pageCount, setPageCount] = useState(0);
const [search, setSearch] = useState("");
const[menuAllData , setMenuAllData ] = useState([])
const [open, setOpen] = useState(false)
const menuLoad  = useSelector((state) => state.menuLoad)
const validationSchema = yup.object({
    roleData: yup.object().required(),
});
  console.log(menuLoad.isOpen)
const formik = useFormik({
    initialValues:{
        roleData : null
    },
    validationSchema : validationSchema
})
const getRoletdata = () => {
    axios.get('/v1/role/list/1')
    .then((res) => {
        setRolesData(res.data)
    })
    .catch((err) => {
      console.log(err)
    })
  }
    const getAuthData = () =>{
        axios.get(`/v1/menuauth/list/1/${rolesId}`)
        .then(res=>{
          setData(res.data)
        })
        .catch(err=>{
          console.log(err)
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
        })
      }
      const updateMenuSetting = (e, value) => {
        console.log(e)
        console.log(value)
        const menuDatas = {
          role_id:rolesId, 
          menu_id:e.menu_id,
          submenu_id:value.submenu_id,
          company_id:1,
          checked:!value.checked
        }
        setIsLoader(true)
        axios
      .post("/v1/menuauth", menuDatas)
      .then((res) => {
        console.log(res)
        getMenuAllData()
        setIsLoader(false)
        getAuthData()
        dispatch(loadNav());
        console.log(menuLoad.isOpen)
        setTimeout(() => {
              dispatch(closeNav())
        },500)
        // if( dispatch(loadNav())){
        // dispatch(closeNav())
        // console.log(menuLoad.isOpen)
        // }
      })
      .catch((err) => console.log(err));
      }
      const rolesId = formik.values.roleData === null ? null : formik.values.roleData.id
//menu all data
      const getMenuAllData = () => {
        axios.get('v1/menuauth/all/1')
        .then((res) => {
          console.log(res)
          setMenuAllData(res.data)
        })
        .catch((err) =>{
          console.log(err)
        })
      }
      useEffect(() => {
        if(rolesId !== null){
            getAuthData()
        }
      },[rolesId ])
      useEffect(() => {
        getRoletdata()
        getMenuAllData()
      },[])
      console.log(formik.values.roleData)
      // console.log(_.map(data , (valu , idx)=>_.map(valu.submenus , (value) => value.submenu_id) ) )
      // console.log(_.map(menuAllData , (val,idx) => _.map(val.submenus , (value) => value.submenu_id)))
  return (
    <Fragment>
      <Helmet>
        <title>Menu Authorization</title>
      </Helmet>
        <Typography variant='h5'>Menu Authorization</Typography>
        <Grid container>
            <Grid item xs={12} md={4} lg={3} >
              <CustomdropDown
                id="roleData"
                data={rolesData}
                optionLabel={(option) => option.role_name}
                value={formik.values.roleData}
                onchange={(e, value) => {
                  formik.setFieldValue("roleData", value);
                }}
                optionEqual={(option, value) => option.role_name === value.role_name}
                placeholder="Select Category"
                helperText={formik.touched.roleData && formik.errors.roleData}
                errorMsg={
                  formik.touched.roleData && Boolean(formik.errors.roleData)
                }
                title="Roles"
              />
            </Grid>
            
        </Grid>
        {formik.values.roleData !== null &&
        <Grid container>
        {_.map(menuAllData , (value,idx) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={idx}>
            <Card className={classes.menuCard}>
              <CardHeader title={value.menu_name} />
                <Divider />
                {_.map(value.submenus , (val , idx) => (
                  <CardContent key={idx}>
                      <FormControlLabel  
                            control={
                              <Checkbox size='small'
                              checked={data.some((dataItem) =>
                                dataItem.submenus.some((dataSubMenu) => dataSubMenu.submenu_id === val.submenu_id)
                              )}
                              // checked={_.map(data , (valu , idx)=>_.map(valu.submenus , (value) => value.submenu_id) ) === _.map(menuAllData , (val,idx) => _.map(val.submenus , (value) => value.submenu_id)) ? true : false }
                              onClick={() => updateMenuSetting(value , val)}
                              />
                            }
                            label={val.sub_menu_name}
                          />
                  </CardContent>
                ))}
            </Card>
          </Grid>
        ))}

      </Grid>
        }

       
        <Grid container>

       
        {/* {rolesId !== null 
            ? _.map(data, (val) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={val.id}>
                  <Card className={classes.menuCard}>
                    <CardHeader title={val.menu_name} />
                    <Divider />
                    {_.map(subMenuData , (value , idx) => 
                      val.menu_id === value.menu_id ?  (
                          <CardContent key={idx}>
                          <FormControlLabel  
                              control={
                                <Checkbox size='small'
                                checked= {_.map(subMenuData , (val) => val.is_active === true ? active : null)}
                                onChange={() => setActive(!active)}
                                />
                              }
                              label={value.sub_menu_name}
                            />
                          </CardContent>
                        ): null
                      )}
                  </Card>
                </Grid>
              ))
            : null} */}

        </Grid>
        {/* <Loader isLoader={isLoader} /> */}
   
    </Fragment>
  )
}

export default MenuAuthorization